declare global {
  const __APP_VERSION__: string;
  const __APP_DESCRIPTION__: string;
  const __APP_ID_OUTLOOK__: string;
  const __APP_ID_EXCEL__: string;
  const __APP_ID_WORD__: string;
  const __APP_TITLE__: string;
  const __APP_BASE_URL__: string;
  const __BRANCH_NAME__: string;
  const __COMMIT_HASH__: string;
  const __ENVIRONMENT__: string;
}

export const defineGlobals = undefined;
